import React, { useEffect, useState } from "react";
import { useInView } from "react-intersection-observer";
import { statsEn, statsFr } from "./utils";

const Stats = () => {
  const language = localStorage.getItem("selectedLanguage");

  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.5,
  });

  const stats = language?.includes("fr") ? statsFr : statsEn;

  return (
    <div ref={ref}>
      <div className="pt-12 grid grid-cols-4 items-start justify-between gap-6 max-md:grid-cols-2 max-[520px]:grid-cols-1 h-full">
        {stats.map((stat, index) => (
          <div
            key={index}
            className={`flex justify-center items-center gap-3 ${index < stats?.length - 1 ? "border-r border-black" : ""} pr-6 h-full max-md:border-0 max-md:px-0 text-center`}
          >
            <div>
              <h4 className="text-black font-medium text-[32px] font-lexend ">
                {inView ? <CountUp end={stat.value} /> : 0}
                {stat.suffix}
              </h4>
              <p className="text-[#00000080] text-[20px] font-lexend font-normal">
                {stat.label}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
const CountUp = ({ end, duration = 2000 }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let start = 0;
    const increment = end / (duration / 16); // ~60fps
    const timer = setInterval(() => {
      start += increment;
      if (start >= end) {
        setCount(end);
        clearInterval(timer);
      } else {
        setCount(Math.floor(start));
      }
    }, 16);

    return () => clearInterval(timer);
  }, [end, duration]);

  // Format numbers with commas
  const formattedCount =
    end >= 1000 ? count.toLocaleString() : count.toString();

  return <span>{formattedCount}</span>;
};

export default Stats;
